import config from 'config';
import { routerForBrowser } from 'redux-little-router';
import routes from './routes';

export { routeMap } from './routes';
export { routes };

export const { reducer, middleware, enhancer } = routerForBrowser({
  routes,
  basename: config.basePath,
});
